import React, { useEffect } from "react";
import "./kontaktFormular.scss";
import KontaktFormularForm from "./kontaktFormularForm";
export default function KontaktFormular() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <div className="kontakt-formular-all-content-alignment">
        <div className="container">
          <div className="text-grid">
            <div className="text-grid-items">
              <div className="divider"></div>
            </div>
            <div className="text-grid-items">
              <h1>Suchauftrag</h1>
            </div>
          </div>
          <div className="child-text-style">
            <p>
              Verwenden Sie unser Suchauftragsformular, damit wir Ihr
              Wunschobjekt für Sie finden können! Füllen Sie bitte alles
              vollständig aus. Pflichtfelder sind mit einem * gekennzeichnet.
            </p>
          </div>
          <KontaktFormularForm />
        </div>
      </div>
    </div>
  );
}
